import { render, staticRenderFns } from "./NewPaymentCheckbox.vue?vue&type=template&id=12ec9bbd&"
import script from "./NewPaymentCheckbox.vue?vue&type=script&lang=js&"
export * from "./NewPaymentCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports